// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provision-preview[data-v-d6fb6256]{border:1px solid var(--color-border-dark);border-radius:var(--border-radius)}\n", ""]);
// Exports
module.exports = exports;
